/** @jsxImportSource @emotion/react */
import { getActivityLogWhen } from '@/Client/Lib';
import type { ActivityLogTableColumn } from './activityLogTableTypes';
import { ActivityLogTableWho } from './ActivityLogTableWho';

/** When it happened: "MAR 6th" over "9:05am". */
export const whenColumn: ActivityLogTableColumn = {
  key: 'when',
  srHeading: 'Date',
  colStyle: styles => styles.whenColumn,
  cellStyle: styles => styles.whenCell,
  render: ({ at }, styles) => {
    const when = getActivityLogWhen(at);
    return (
      <>
        <span css={styles.day}>
          <span css={styles.month}>{when.month}</span> {when.day}
          <sup css={styles.ordinal}>{when.ordinal}</sup>
        </span>
        <span css={styles.time}>{when.time}</span>
      </>
    );
  },
};

/** The entry's own mark, on the timeline rail that runs through this column. */
export const markColumn: ActivityLogTableColumn = {
  key: 'mark',
  srHeading: 'Status',
  colStyle: styles => styles.markColumn,
  cellStyle: (styles, { isFirst, isLast }) => [styles.markCell, isFirst && styles.firstMarkCell, isLast && styles.lastMarkCell],
  render: ({ mark }, styles) => <span css={styles.mark}>{mark}</span>,
};

/** Who did it: "First L.", resolved from the entry's actor. */
export const whoColumn: ActivityLogTableColumn = {
  key: 'who',
  heading: 'Who',
  colStyle: styles => styles.whoColumn,
  cellStyle: styles => styles.whoCell,
  render: ({ actorUserId }) => <ActivityLogTableWho userId={actorUserId} />,
};

/** What happened: the name, in the alert tone when the entry asks for it, over its detail. */
export const whatColumn: ActivityLogTableColumn = {
  key: 'what',
  heading: 'What',
  render: ({ name, detail, tone = 'default' }, styles) => (
    <>
      <div css={tone === 'alert' ? styles.alertName : styles.name} data-tone={tone}>{name}</div>
      {detail ? <div css={styles.detail}>{detail}</div> : null}
    </>
  ),
};

/** The document the event produced or refers to, or "—". */
export const artifactColumn: ActivityLogTableColumn = {
  key: 'artifact',
  heading: 'Artifact',
  colStyle: styles => styles.artifactColumn,
  cellStyle: styles => styles.artifactCell,
  render: ({ artifact }) => artifact ?? '—',
};
